
<template>

  <div class="m-2">
    <loading-spinner v-if="loading" />
    <template v-else>
      <div v-if="this.ids.length > 0" class="row">
        <div class="column">
            <h5>Select a date range</h5>
            <vue-ctk-date-time-picker
            id="RangeDatePicker"  label="Current Month" v-model="range_value"
            format="YYYY-MM-DD" range = true formatted="ll">
              <b-button variant="primary"
                class="m-2" size="md">Current Month</b-button>
          </vue-ctk-date-time-picker>
        </div>
        <div class="column">

        </div>
      </div>



        <b-row>
            <b-col v-for="insight in this.chart_insights" :key="insight.id" cols :md="6" :sm="12">
              <categorical-key-insight
                :values="insight.data"
                :chart="insight.chart"
                :plotOptions="insight.plotOptions"
                :isString=true
                :name="insight.title"
                :title="insight.title"></categorical-key-insight>
            </b-col>
              <br/>
          </b-row>

        <div v-for="insight in this.table_insights" :key="insight.id">
          <list-key-insight
            class="mb-2; mt-2"
            :values="insight.data"
            :tableName="insight.title"
            :insightId="insight.id"
            :rowCount="insight.data.length"
            />
            <br/>
        </div>
        <div class="text-center m-5"></div>

    </template>
  </div>
</template>

<script>
import axios from "axios";
import { fullURL } from "../../utils";
import LoadingSpinner from "../LoadingSpinner";
import CategoricalKeyInsight from "../Insights/CategoricalKeyInsight";
import ListKeyInsight from '../List/ListKeyInsight';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

import moment from "moment";


const parseCategory = (value, type) => {
  if (type === "date") {
    return moment(value).format("MMM DD, YYYY");
  }
  return value;
};

export default {
  name: "KeyInsights",

  components: {
    LoadingSpinner,
    CategoricalKeyInsight,
    ListKeyInsight,

    VueCtkDateTimePicker
  },

  props: {
    keyInsightIDs: Array
  },

  data() {
    return {
      range_value:null,
      chart_insights: [],
      table_insights: [],
      loading: true,
      ids: this.keyInsightIDs,
      stringify: JSON.stringify,
      title: null,
    };
  },

  created() {
    const today = new Date();
    const start = new Date(today.getFullYear(), 0, 1, 1).toISOString().slice(0, 10);
    const end_date = new Date(today.getFullYear(), today.getMonth() + 1, 1, 1);
    end_date.setDate(end_date.getDate() - 1);
    const end = end_date.toISOString().slice(0, 10);
    if (this.ids.length > 0) {
      this.ids.forEach(id =>
      axios
        .get(
          fullURL(
            `/custom-reports/key-insights/${id}/?start=${start}&end=${end}`
          )
        )
        .then(({ data }) => {
          if (!!data) {
            data['id'] = id;
            if (data.chart == 'table') {
              this.table_insights.push(data);
            } else {
              this.chart_insights.push(data);
            }
          }
        })
        .catch(console.log)
        .finally(() => {
          this.loading = false;
        })
      );
    } else {
      this.loading = false;
    }
  },
  watch:{
    range_value(val){
      const {start, end} = val;
      console.log("start_date",start);
      this.table_insights = [];
      this.chart_insights = [];
      this.ids.forEach(id =>
        axios
          .get(
            fullURL(
              `/custom-reports/key-insights/${id}/?start=${start}&end=${end}`
            )
          )
          .then(({ data }) => {
            if (!!data) {
              data['id'] = id;
              if (data.chart == 'table') {
                this.table_insights.push(data);
              } else {
                this.chart_insights.push(data);
              }
            }
          })
          .catch(console.log)
          .finally(() => {
            this.loading = false;
          })
      );
    }
  }

};
</script>

<style scoped>
</style>
